module.exports = __webpack_public_path__ + "static/img/4_3_2.a2e24910.jpg";